import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';

export const Footer = () => {
  const { t } = useTranslation('common');
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer">
      <div className="footer-content">
        <nav className="footer-links">
          <Link to="/about">{t('footer.about')}</Link>
          <Link to="/terms">{t('footer.terms')}</Link>
          <Link to="/privacy">{t('footer.privacy')}</Link>
          <Link to="/cookie-policy">{t('footer.cookies')}</Link>
          <Link to="/accessibility">{t('footer.accessibility')}</Link>
          <Link to="/contact">{t('footer.contact')}</Link>
        </nav>
        <div className="footer-bottom">
          <p>{t('footer.copyright', { year: currentYear })}</p>
        </div>
      </div>
    </footer>
  );
}; 